import { COMPANY_ROUTE_PREFIXES, PROPERTY_ROUTE_PREFIXES } from 'garaje/router';

export type RouteScope = 'company' | 'zone' | 'location';

export function resolveRouteScope(routeName: string | null | undefined): RouteScope {
  if (matchesPrefix(routeName, PROPERTY_ROUTE_PREFIXES)) return 'zone';
  if (matchesPrefix(routeName, COMPANY_ROUTE_PREFIXES)) return 'company';
  return 'location';
}

function matchesPrefix(name: string | null | undefined, prefixes: readonly string[]): boolean {
  if (!name) return false;
  return prefixes.some((prefix) => name === prefix || name.startsWith(`${prefix}.`));
}
